import api from '../../../services/Api';
import { IAuditoriaDespesasAntecipadasResultado } from '../interfaces/IAuditoriaDespesasAntecipadas';

export const AuditoriaDespesasAntecipadasService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaDespesasAntecipadasResultado> {
    const response = await api.get<IAuditoriaDespesasAntecipadasResultado>('auditoria-despesas-antecipadas/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoEstagnacao: '',
        fundamentacaoQuebraCompetenciaFiscal: '',
        fundamentacaoQuebraCompetenciaContabil: '',
        despesasEstagnadas: [],
        despesasConciliadas: [],
        quebraCompetenciaMensal: [],
      }
    );
  },
};
